// extracted by mini-css-extract-plugin
export default {"outerBox":"NoDue_outerBox__L+7lk","innerBox":"NoDue_innerBox__6TJR9"};